export type RewardsDiscountLevel = {
  id: string
  label: string
  minDiscountBrl: number
  badgeColor: 'default' | 'primary' | 'secondary' | 'info' | 'success' | 'warning' | 'error'
}

const LEVELS: RewardsDiscountLevel[] = [
  { id: 'starter', label: 'Iniciante', minDiscountBrl: 0, badgeColor: 'default' },
  { id: 'bronze', label: 'Bronze', minDiscountBrl: 5, badgeColor: 'warning' },
  { id: 'silver', label: 'Prata', minDiscountBrl: 20, badgeColor: 'info' },
  { id: 'gold', label: 'Ouro', minDiscountBrl: 50, badgeColor: 'success' },
  { id: 'diamond', label: 'Diamante', minDiscountBrl: 100, badgeColor: 'primary' },
  { id: 'legend', label: 'Lendário', minDiscountBrl: 200, badgeColor: 'secondary' },
] as const

export type RewardsLevelProgress = {
  current: RewardsDiscountLevel
  next: RewardsDiscountLevel | null
  progressPct: number
  missingDiscountBrl: number | null
}

export function getRewardsLevelProgress(discountBrl: number): RewardsLevelProgress {
  const raw = Number(discountBrl || 0)
  const value = Number.isFinite(raw) ? Math.max(0, raw) : 0

  let current = LEVELS[0]
  for (const lvl of LEVELS) {
    if (value >= lvl.minDiscountBrl) current = lvl
  }
  const idx = LEVELS.findIndex((l) => l.id === current.id)
  const next = idx >= 0 ? LEVELS[idx + 1] ?? null : null

  if (!next) {
    return { current, next: null, progressPct: 100, missingDiscountBrl: null }
  }

  const target = Math.max(0.01, Number(next.minDiscountBrl))
  const progressPct = Math.max(0, Math.min(100, (value / target) * 100))
  const missingDiscountBrl = Math.max(0, target - value)

  return { current, next, progressPct, missingDiscountBrl }
}

